exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/quote-settings/quote-templates/create-edit-quote-template-modal/create-edit-quote-template-modal.component.css
// module id = 735
// module chunks = 0